import * as React from "react";
const SvgStyleCircleRemove = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" viewBox="0 0 18 18" {...props}><circle cx={9} cy={9} r={9} fill="#E85154" /><path fill="#fff" d="M13 8H5v2h8z" /></svg>;
export default SvgStyleCircleRemove;